import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const GetTenantProfile = createAsyncThunk(
  "tenantProfile/GetTenantProfile",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("ots_token");
      let response = await axios.get(
        `${BASE_URL}/tenant-profile/${userId}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Failed to fetch profile" });
    }
  }
);

const GetTenantProfileSlice = createSlice({
  name: "getTenantProfile",
  initialState: {
    loading: false,
    profile: null,
    error: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetTenantProfile.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(GetTenantProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
        state.loading = false;
      })
      .addCase(GetTenantProfile.rejected, (state, action) => {
        state.error = action.payload?.message || "Failed to fetch profile";
        state.loading = false;
      });
  },
});

export default GetTenantProfileSlice.reducer;
